
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/yundongyuan/options',

  levelApplyMemberList: '/adminapi/yundongyuan/levelApplyMemberList',
  levelApplyMemberDetail: '/adminapi/yundongyuan/levelApplyMemberDetail',
  editLevelApplyMember: '/adminapi/yundongyuan/levelApplyMemberEdit',
  deleteLevelApplyMember: '/adminapi/yundongyuan/levelApplyMemberDelete',

  levelApplyList: '/adminapi/yundongyuan/levelApplyList',
  levelApplyDetail: '/adminapi/yundongyuan/levelApplyDetail',
  editLevelApply: '/adminapi/yundongyuan/levelApplyEdit',
  deleteLevelApply: '/adminapi/yundongyuan/levelApplyDelete',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}

export function getLevelApplyMemberList(parameter) {
  return axios({
    url: api.levelApplyMemberList,
    method: 'get',
    params: parameter
  })
}

export function getLevelApplyMemberDetail(parameter) {
  return axios({
    url: api.levelApplyMemberDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelApplyMember(parameter) {
  return axios({
    url: api.editLevelApplyMember,
    method: 'post',
    data: parameter
  })
}

export function deleteLevelApplyMember(parameter) {
  return axios({
    url: api.deleteLevelApplyMember,
    method: 'post',
    data: parameter
  })
}

export function getLevelApplyList(parameter) {
  return axios({
    url: api.levelApplyList,
    method: 'get',
    params: parameter
  })
}

export function getLevelApplyDetail(parameter) {
  return axios({
    url: api.levelApplyDetail,
    method: 'get',
    params: parameter
  })
}

export function editLevelApply(parameter) {
  return axios({
    url: api.editLevelApply,
    method: 'post',
    data: parameter
  })
}

export function deleteLevelApply(parameter) {
  return axios({
    url: api.deleteLevelApply,
    method: 'post',
    data: parameter
  })
}
